var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Motion',{staticClass:"h-3 w-3 bg-indigo-600 rounded-full",attrs:{"auto":['scale-0 opacity-0', 'scale-100 opacity-100'],"options":{
    repeat: true,
    duration: 500,
    factor: 4,
    skip: 1,
    instantRollback: true,
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }